
    var riot = require('riot')
    riot.tag2('gb-select-button', '<yield> <span class="gb-button__label">{$select.selectLabel()}</span> <img riot-src="{$selectable.iconUrl}" alt=""> </yield>', 'gb-select-button img,[data-is="gb-select-button"] img{ margin-left: 10px; margin-top: 2px; height: 24px; }', '', function(opts) {
    this.root.addEventListener('focus', this.$select.prepFocus);
    this.root.addEventListener('click', this.$select.unFocus);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/select/gb-select-button.tag.html